import React, { useEffect } from 'react';

export const ResponsiveModal = ({
  isOpen,
  onClose,
  title,
  children,
  primaryButtonText = 'تایید',
  secondaryButtonText = 'انصراف',
  onPrimaryClick,
  onSecondaryClick,
  showButtons = true,
}) => {
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    const handleWheel = (e) => {
      if (isOpen) {
        e.preventDefault();
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('wheel', handleWheel, { passive: false });
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('wheel', handleWheel);
    };
  }, [isOpen, onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePrimaryClick = () => {
    if (onPrimaryClick) {
      onPrimaryClick();
    } else {
      onClose();
    }
  };

  const handleSecondaryClick = () => {
    if (onSecondaryClick) {
      onSecondaryClick();
    } else {
      onClose();
    }
  };

  if (!isOpen) return null;

  const overlayStyle = {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    width: '100vw',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '2147483647',
    opacity: isOpen ? '1' : '0',
    visibility: isOpen ? 'visible' : 'hidden',
    transition: 'all 0.3s ease',
    backdropFilter: 'blur(5px)',
    margin: '0',
    padding: '0',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
    direction: 'rtl',
  };

  const modalStyle = {
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 25px 60px rgba(0, 0, 0, 0.3)',
    maxWidth: '500px',
    width: '90%',
    maxHeight: '80vh',
    overflow: 'hidden',
    transform: isOpen ? 'scale(1) translateY(0)' : 'scale(0.8) translateY(-50px)',
    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
    position: 'relative',
    margin: '0',
    padding: '0',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    zIndex: '2147483647',
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, #01494b, #016366)',
    color: 'white',
    padding: '25px',
    textAlign: 'center',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const titleStyle = {
    fontSize: '14px',
    fontWeight: 'bold',
    margin: '0',
    padding: '0',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    lineHeight: '1.2',
  };

  const closeBtnStyle = {
    position: 'absolute',
    top: '15px',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '24px',
    cursor: 'pointer',
    width: '35px',
    height: '35px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'all 0.3s ease',
    margin: '0',
    padding: '0',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    lineHeight: '1',
  };

  const contentStyle = {
    padding: '30px',
    textAlign: 'center',
    lineHeight: '1.6',
    margin: '0',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  };

  const buttonsStyle = {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: '25px',
    margin: '25px 0 0 0',
    padding: '0',
    border: 'none',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const btnBaseStyle = {
    padding: '12px 25px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: '120px',
    width: '45%',
    margin: '0',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    lineHeight: '1',
  };

  const primaryBtnStyle = {
    ...btnBaseStyle,
    background: '#01494b',
    color: 'white',
    boxShadow: '0 5px 15px rgba(1, 73, 75, 0.3)',
  };

  const secondaryBtnStyle = {
    ...btnBaseStyle,
    background: 'transparent',
    color: '#01494b',
    border: '2px solid #01494b',
  };

  // استایل‌های موبایل - مودال همچنان در وسط باقی می‌ماند
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    // overlayStyle.alignItems = 'center'; // همین خط رو حذف کردیم چون قبلاً center هست
    overlayStyle.padding = '20px'; // کمی padding اضافه کردیم

    modalStyle.width = '95%'; // کمی کوچک‌تر کردیم
    modalStyle.maxWidth = 'none';
    modalStyle.borderRadius = '12px'; // گوشه‌ها رو گرد نگه داشتیم
    modalStyle.maxHeight = '85vh';
    modalStyle.margin = '0';
    // انیمیشن رو هم تغییر ندادیم

    contentStyle.padding = '25px 20px';

    buttonsStyle.flexDirection = 'row';

    btnBaseStyle.width = '100%';
  }

  return (
    <div style={overlayStyle} onClick={handleOverlayClick}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <button
            style={closeBtnStyle}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)';
              e.target.style.transform = 'rotate(90deg)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'none';
              e.target.style.transform = 'rotate(0deg)';
            }}
          >
            ×
          </button>
          <h2 style={titleStyle}>{title}</h2>
        </div>

        <div style={contentStyle}>
          <div
            style={{
              color: '#555',
              marginBottom: '25px',
              fontSize: '16px',
              margin: '0 0 25px 0',
              padding: '0',
              border: 'none',
              outline: 'none',
              boxSizing: 'border-box',
              fontFamily: 'inherit',
              lineHeight: '1.6',
            }}
          >
            {children}
          </div>

          {showButtons && (
            <div style={buttonsStyle}>
              <button
                style={secondaryBtnStyle}
                onClick={handleSecondaryClick}
                onMouseEnter={(e) => {
                  e.target.style.background = '#01494b';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#01494b';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                {secondaryButtonText}
              </button>
              <button
                style={primaryBtnStyle}
                onClick={handlePrimaryClick}
                onMouseEnter={(e) => {
                  e.target.style.background = '#016366';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 8px 25px rgba(1, 73, 75, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#01494b';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 5px 15px rgba(1, 73, 75, 0.3)';
                }}
              >
                {primaryButtonText}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
